import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';

import {
  NavBar,
  HeadingDisplay,
  Heading,
  BaseIcon,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { removeBodyScroll } from '@/modules/common/helpers/browser';

enum ERiskGrade {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH'
}

interface IData {
  customerRiskProfile: {
    label: string;
    value: string;
  }[];
  requestRisksSignature: {
    formatted: {
      formatted: string;
      value: string;
    };
    label: string;
    productId: string;
  }[];
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}
interface Props {
  isOpen: boolean;
  data: IData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RiskSignature',
  props: {
    isOpen: { type: Boolean },
    data: null
  },
  emits: ["close", "confirm"],
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  data: IData;
}





const risks = computed(() => {
  return [
    {
      class: 'low',
      isSelected:
        props.data.requestRisksSignature[0].formatted.value === ERiskGrade.LOW
    },
    {
      class: 'medium',
      isSelected:
        props.data.requestRisksSignature[0].formatted.value ===
        ERiskGrade.MEDIUM
    },
    {
      class: 'high',
      isSelected:
        props.data.requestRisksSignature[0].formatted.value === ERiskGrade.HIGH
    }
  ];
});

const details = computed(() => {
  const risk = {
    label: props.data.requestRisksSignature[0].label,
    value: props.data.requestRisksSignature[0].formatted.formatted
  };

  const list = props.data.customerRiskProfile;
  list.push(risk);

  return list;
});

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,ERiskGrade, props, risks, details, NavBar, HeadingDisplay, Heading, BaseIcon, ListDisplay, ButtonContainer, ButtonPrimary, SideSheet, BackButton }
}

})